import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Adam Intop -> Populate Default Analyser Actions
 * Details (v4/api, `App\Settings\Easeedesk\AdamIntopDefaultActions`) si
 * cele doua cautari in cascada ale formularului (fostele
 * `Diagnostic::get_subcategories_by_cat_id` / `get_operations_by_subcat_id`).
 * Forma paginii e inghetata in `settings/easeedesk/__fixtures__/
 * adamDefaultActions.json`.
 */
const BASE = '/settings/easeedesk/adam_intop/default_actions'

export interface AdamDefaultsPage {
  providerName: string
  categories: { ID: number; category_name: string }[]
  all_ticket_types: { ID: number; type_name: string; short_name: string }[]
  allCompaniesSp: { ID: number; name: string }[]
  count_default_active_actions_for_this_sp: number
}

export function adamDefaultsPageQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'adam_intop', 'default_actions'],
    queryFn: () => apiGet<AdamDefaultsPage>(BASE),
  })
}

export function categorySubcategoriesQuery(category: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'categories', category, 'subcategories'],
    queryFn: () =>
      apiGet<{ subcategories: { ID: number; subcategory_name: string; category_id: number }[] }>(
        `/settings/easeedesk/categories/${category}/subcategories`,
      ),
    enabled: category > 0,
  })
}

export function subcategoryOperationsQuery(subcategory: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'subcategories', subcategory, 'operations'],
    queryFn: () =>
      apiGet<{ operations: { ID: number; operation_name: string; subcategory_id: number }[] }>(
        `/settings/easeedesk/subcategories/${subcategory}/operations`,
      ),
    enabled: subcategory > 0,
  })
}

export interface AdamDefaultsForm {
  category: string
  subcategory: string
  operation: string
  run_only_on_ticket_types: string[]
  run_only_on_companies: string[]
}

/** `populate_default_actions_details_save`, cu campurile formularului vechi. */
export function populateAdamDefaults(form: AdamDefaultsForm) {
  return apiPost<{ status: number; message: string; result?: number | null }>(BASE, {
    category: form.category,
    subcategory: form.subcategory,
    operation: form.operation,
    run_only_on_ticket_types: form.run_only_on_ticket_types,
    run_only_on_companies: form.run_only_on_companies,
  })
}
